import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f4450e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { key: 2 }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("已启用")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("已禁用")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("编辑")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_card = _resolveComponent("a-card")!
  const _component_ImageView = _resolveComponent("ImageView")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, {
      title: "车辆列表",
      style: {"margin-bottom":"16px"},
      bordered: ""
    }),
    _createVNode(_component_a_table, {
      dataSource: _ctx.list,
      columns: _ctx.columns,
      rowKey: "id",
      loading: _ctx.loading,
      bordered: "",
      pagination: _ctx.pagination,
      onChange: _ctx.handleTableChange
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.key === 'vehicle_travel_license_number')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", null, "车牌号：" + _toDisplayString(record.plate_number || record.vehicle_travel_license_number), 1),
              _hoisted_1,
              _createElementVNode("span", null, "类型：" + _toDisplayString(record.vehicle_travel_type + "/" + record.vehicle_type), 1),
              _hoisted_2,
              _createElementVNode("span", null, "体积：长" + _toDisplayString(record.car_long) + "米 宽" + _toDisplayString(record.car_width) + "米 高" + _toDisplayString(record.car_height) + "米", 1),
              _hoisted_3,
              _createElementVNode("span", null, "核载：" + _toDisplayString(record.standard_weight) + "吨", 1),
              _hoisted_4,
              _createElementVNode("span", null, "车辆类型：" + _toDisplayString(record.vehicle_type), 1)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'vehicle_images')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_a_row, { gutter: 16 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ImageView, {
                        "image-url": text.front
                      }, null, 8, ["image-url"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ImageView, {
                        "image-url": text.back
                      }, null, 8, ["image-url"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_a_row, {
                gutter: 16,
                style: {"margin-top":"16px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ImageView, {
                        "image-url": text.left
                      }, null, 8, ["image-url"])
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_col, { span: 12 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ImageView, {
                        "image-url": text.right
                      }, null, 8, ["image-url"])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'road_transportation_permit_card')
          ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(text), 1))
          : _createCommentVNode("", true),
        (column.key === 'vehicle_travel_time')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("span", null, "类型：" + _toDisplayString(record.vehicle_travel_type), 1),
              _hoisted_6,
              _createElementVNode("span", null, "有效期至：" + _toDisplayString(_ctx.dayjs(text * 1000).format("YYYY-MM-DD")), 1),
              (record.vehicle_travel_license_images)
                ? (_openBlock(), _createBlock(_component_a_row, {
                    key: 0,
                    gutter: 16,
                    style: {"margin-top":"16px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ImageView, {
                            "image-url": record.vehicle_travel_license_images.front
                          }, null, 8, ["image-url"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ImageView, {
                            "image-url": record.vehicle_travel_license_images.sub
                          }, null, 8, ["image-url"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ImageView, {
                            "image-url": record.vehicle_travel_license_images.record
                          }, null, 8, ["image-url"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'vehicle_travel_license_images')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
              _createElementVNode("span", null, "经营许可证号： " + _toDisplayString(record.road_transportation_permit_card), 1),
              (record.road_transportation_images)
                ? (_openBlock(), _createBlock(_component_a_row, {
                    key: 0,
                    gutter: 16,
                    style: {"margin-top":"16px"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ImageView, {
                            "image-url": record.road_transportation_images.front
                          }, null, 8, ["image-url"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_a_col, { span: 8 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ImageView, {
                            "image-url": record.road_transportation_images.sub
                          }, null, 8, ["image-url"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'status')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
              text
                ? (_openBlock(), _createBlock(_component_a_tag, {
                    key: 0,
                    color: "green"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_a_tag, {
                    key: 1,
                    color: "red"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_8
                    ]),
                    _: 1
                  }))
            ], 64))
          : _createCommentVNode("", true),
        (column.key === 'action')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
              (record.status)
                ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                    key: 0,
                    title: "是否禁用分类?",
                    onConfirm: ($event: any) => (_ctx.changeStatus(record))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_button, {
                        size: "small",
                        danger: "",
                        style: {"margin":"5px"}
                      }, {
                        default: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 1
                      })
                    ]),
                    _: 2
                  }, 1032, ["onConfirm"]))
                : (_openBlock(), _createBlock(_component_a_button, {
                    key: 1,
                    size: "small",
                    onClick: ($event: any) => (_ctx.changeStatus(record)),
                    style: {"margin":"5px"}
                  }, {
                    default: _withCtx(() => [
                      _hoisted_10
                    ]),
                    _: 2
                  }, 1032, ["onClick"])),
              _createVNode(_component_a_button, {
                size: "small",
                onClick: ($event: any) => (_ctx.goSet(record)),
                style: {"margin":"5px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 2
              }, 1032, ["onClick"])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["dataSource", "columns", "loading", "pagination", "onChange"])
  ]))
}